import { render, staticRenderFns } from "./viewStudentAnswers.vue?vue&type=template&id=14876f00&scoped=true"
import script from "./viewStudentAnswers.vue?vue&type=script&lang=js"
export * from "./viewStudentAnswers.vue?vue&type=script&lang=js"
import style0 from "./viewStudentAnswers.vue?vue&type=style&index=0&id=14876f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14876f00",
  null
  
)

export default component.exports